
// import { useState, useEffect } from "react";
// import axios from "axios";

// interface TeamIncomeItem {
//   _id: string;
//   emailOwner: string;
//   emailMember: string;
//   Income: string;
//   createdAt: string;
//   level?: number | "N/A";
// }

// const TeamIncome = () => {
//   const [teamIncome, setTeamIncome] = useState<TeamIncomeItem[]>([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     const fetchTeamIncome = async () => {
//       try {
//         setIsLoading(true);
//         const headers = {
//           "Content-Type": "application/json",
//         };

//         const response = await axios.get<{ teamIncome: Record<string, TeamIncomeItem> }>(
//           `${API_BASE}/api/teamincome/getIncomeTeamAll`,
//           { headers }
//         );

//         if (response.data.teamIncome) {
//           let incomeData: TeamIncomeItem[] = Object.values(response.data.teamIncome);

//           // Fetch levels for each entry
//           const levelPromises = incomeData.map((item) =>
//             axios
//               .get<{ SubTeam: Record<string, { level?: number }> }>(
//                 `${API_BASE}/api/subTeam/getsubTeam/${item.emailOwner}/${item.emailMember}`,
//                 { headers }
//               )
//               .then((res) => {
//                 const level = Object.values(res.data.SubTeam)[0]?.level;
//                 return typeof level === "number" ? level : "N/A";
//               })
//               .catch(() => "N/A")
//           );

//           const levels = await Promise.all(levelPromises);

//           // Merge levels with data
//           const finalData = incomeData.map((item, index) => ({
//             ...item,
//             level: levels[index] as number | "N/A",
//           }));

//           setTeamIncome(finalData);
//         }
//       } catch (error) {
//         console.error("Error fetching team income:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchTeamIncome();
//   }, []);

//   const filteredData = teamIncome.filter(
//     (item) =>
//       item.emailOwner.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.emailMember.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div className="max-w-6xl mx-auto p-6">
//       <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">Team Income</h1>

//       {/* Search Bar */}
//       <input
//         type="text"
//         placeholder="Search by email..."
//         value={searchTerm}
//         onChange={(e) => setSearchTerm(e.target.value)}
//         className="w-full p-3 border rounded-lg mb-6 shadow-sm focus:outline-none focus:ring focus:ring-blue-300"
//       />

//       {isLoading ? (
//         <p className="text-center text-gray-500">Loading...</p>
//       ) : filteredData.length === 0 ? (
//         <p className="text-center text-gray-500">No results found.</p>
//       ) : (
//         <div className="space-y-4">
//           {filteredData.map((item, index) => (
//             <div key={index} className="bg-white shadow-md rounded-lg p-4 border border-gray-200">
//               <div className="flex justify-between items-center">
//                 <h2 className="text-lg font-semibold text-gray-800">{item.emailOwner}</h2>
//                 <span className="px-3 py-1 text-sm font-medium bg-gray-100 text-gray-600 rounded-lg">
//                   Level: {item.level}
//                 </span>
//               </div>

//               <p className="text-gray-600 mt-2">
//                 <strong>From:</strong> {item.emailMember}
//               </p>
//               <p className="text-gray-600">
//                 <strong>Date:</strong>{" "}
//                 {new Date(item.createdAt).toLocaleDateString("en-GB", {
//                   day: "2-digit",
//                   month: "short",
//                   year: "numeric",
//                 })}
//               </p>
//               <p className="text-green-600 font-bold text-lg mt-2">
//                 <strong>Income:</strong> ${Number(item.Income || 0).toFixed(2)}
//               </p>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default TeamIncome;
import { useState, useEffect, useLayoutEffect, useCallback } from "react";
import axios from "axios";
import { API_BASE } from "../config";

interface TeamIncomeItem {
  _id: string;
  emailOwner: string;
  emailMember: string;
  Income: number;
  createdAt: string;
  level: number;
}

const TeamIncome = () => {
  const [teamIncome, setTeamIncome] = useState<TeamIncomeItem[]>([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [appliedStart, setAppliedStart] = useState("");
  const [appliedEnd, setAppliedEnd] = useState("");
  const [jumpPage, setJumpPage] = useState("");
  const [limit, setLimit] = useState(20);

  useEffect(() => {
    const t = window.setTimeout(() => setSearch(searchInput.trim()), 400);
    return () => window.clearTimeout(t);
  }, [searchInput]);

  useLayoutEffect(() => {
    setPage(1);
  }, [search, limit, appliedStart, appliedEnd]);

  const fetchPage = useCallback(async (signal?: AbortSignal) => {
    setIsLoading(true);
    try {
      const params: Record<string, string | number> = {
        page,
        limit,
        sortBy: "createdAt",
        sortOrder: "desc",
      };
      if (search) params.searchTerm = search;
      if (appliedStart) params.startDate = appliedStart;
      if (appliedEnd) params.endDate = appliedEnd;

      const res = await axios.get<{
        status: string;
        page: number;
        totalPages: number;
        total?: number;
        teamIncome: TeamIncomeItem[];
      }>(
        `${API_BASE}/api/teamincome/admin/getAllTeamIncomePaginated`,
        { params, signal }
      );

      if (res.data.status === "success") {
        setTeamIncome(res.data.teamIncome);
        setPage(res.data.page);
        setTotalPages(res.data.totalPages);
        setTotal(typeof res.data.total === "number" ? res.data.total : 0);
        setJumpPage(res.data.page.toString());
      } else {
        console.error("API error:", res.data);
      }
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log("Request canceled:", err.message);
      } else {
        console.error("Fetch error:", err);
      }
    } finally {
      setIsLoading(false);
    }
  }, [page, limit, search, appliedStart, appliedEnd]);

  useEffect(() => {
    const controller = new AbortController();
    fetchPage(controller.signal);
    return () => controller.abort();
  }, [fetchPage]);

  const applyFilters = () => {
    setAppliedStart(startDate);
    setAppliedEnd(endDate);
  };

  return (
    <div className="max-w-6xl mx-auto p-4 md:p-6 pb-20">
      <h1 className="text-2xl md:text-3xl font-bold text-[#523680] mb-6 text-center">
        Team Income
      </h1>

      {/* Filters */}
      <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm mb-6 space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label className="block text-xs font-bold text-gray-400 uppercase mb-1">Search</label>
            <input
              type="text"
              placeholder="Owner or Member"
              value={searchInput}
              onChange={e => setSearchInput(e.target.value)}
              className="w-full p-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#523680]/20 outline-none transition-all"
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-bold text-gray-400 uppercase mb-1">From</label>
              <input
                type="date"
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
                className="w-full p-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-[#523680]/20 outline-none transition-all"
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-400 uppercase mb-1">To</label>
              <input
                type="date"
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
                className="w-full p-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-[#523680]/20 outline-none transition-all"
              />
            </div>
          </div>
          <div className="sm:col-span-2 lg:col-span-1 flex items-end">
            <button
              onClick={applyFilters}
              className="w-full px-4 py-2.5 bg-[#523680] text-white rounded-lg hover:bg-[#523680]/90 font-bold transition-all shadow-sm"
            >
              Apply Filters
            </button>
          </div>
        </div>
      </div>

      {/* Pagination Controls at Top */}
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-6 bg-gray-50 p-4 rounded-xl border border-gray-100">
        <div className="flex items-center gap-2">
          <select
            value={limit}
            onChange={(e) => {
              const newLimit = parseInt(e.target.value, 10);
              setLimit(newLimit);
            }}
            className="px-3 py-2 border border-gray-200 rounded-lg text-sm font-semibold text-[#523680] bg-white"
          >
            <option value={20}>20 / page</option>
            <option value={50}>50 / page</option>
            <option value={100}>100 / page</option>
          </select>
          <button
            onClick={() => setPage((p) => Math.max(p - 1, 1))}
            disabled={page === 1 || isLoading}
            className={`px-4 py-2 rounded-lg font-bold text-sm transition-all shadow-sm ${page === 1 || isLoading
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-white text-[#523680] border border-[#523680]/10 hover:border-[#523680]/30 active:scale-95"
              }`}
          >
            Prev
          </button>

          <div className="flex items-center bg-white border border-gray-200 rounded-lg px-3 py-1.5 shadow-sm">
            <span className="text-xs font-bold text-[#523680] whitespace-nowrap">
              Page {page} of {totalPages}
            {total > 0 && (
              <span className="text-gray-400 font-normal ml-1">({total} total)</span>
            )}
            </span>
          </div>

          <button
            onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
            disabled={page === totalPages || isLoading}
            className={`px-4 py-2 rounded-lg font-bold text-sm transition-all shadow-sm ${page === totalPages || isLoading
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-white text-[#523680] border border-[#523680]/10 hover:border-[#523680]/30 active:scale-95"
              }`}
          >
            Next
          </button>
        </div>

        <div className="flex items-center gap-2">
          <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Go to</label>
          <div className="flex items-center gap-1">
            <input
              type="text"
              value={jumpPage}
              onChange={(e) => setJumpPage(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  const p = parseInt(jumpPage);
                  if (p >= 1 && p <= totalPages) {
                    setPage(p);
                  }
                }
              }}
              className="w-14 p-1.5 text-center border border-gray-200 rounded-lg text-sm font-bold text-[#523680] outline-none focus:ring-2 focus:ring-[#523680]/20 transition-all"
            />
            <button
              onClick={() => {
                const p = parseInt(jumpPage);
                if (p >= 1 && p <= totalPages) {
                  setPage(p);
                }
              }}
              disabled={isLoading}
              className="p-1.5 bg-[#523680] text-white rounded-lg hover:bg-[#523680]/90 transition-all disabled:bg-gray-300 shadow-sm"
              title="Jump to page"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6" /></svg>
            </button>
          </div>
        </div>
      </div>

      {/* Data List */}
      {isLoading ? (
        <p className="text-center text-gray-500">Loading...</p>
      ) : teamIncome.length === 0 ? (
        <p className="text-center text-gray-500">No records found.</p>
      ) : (
        <div className="space-y-4">
          {teamIncome.map(item => (
            <div
              key={item._id}
              className="bg-white shadow-sm rounded-xl p-5 border border-gray-100 hover:shadow-md transition-all"
            >
              <div className="flex justify-between items-start mb-3">
                <div className="min-w-0">
                  <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">Owner</p>
                  <h2 className="font-bold text-[#523680] truncate">{item.emailOwner}</h2>
                </div>
                <span className="px-2.5 py-1 bg-[#523680]/10 text-[#523680] text-[10px] font-bold rounded-full border border-[#523680]/5 shrink-0">
                  Lvl {item.level}
                </span>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-3 border-t border-gray-50">
                <div className="min-w-0">
                  <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">From Member</p>
                  <p className="text-sm font-medium text-gray-600 truncate">{item.emailMember}</p>
                </div>
                <div className="flex justify-between items-end sm:items-start sm:flex-col sm:gap-1">
                  <div className="order-2 sm:order-1">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-0.5 sm:hidden text-right">Income</p>
                    <p className="text-lg font-black text-green-600 leading-tight">
                      ${(item.Income ?? 0).toFixed(2)}
                    </p>
                  </div>
                  <p className="text-[10px] font-medium text-gray-400 order-1 sm:order-2">
                    {new Date(item.createdAt).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TeamIncome;
